"use client";

import { c as _c } from "react/compiler-runtime";
import { useSideBarCollapse } from "@store/sideBarCollapse";
import { ColorModeContext } from "@contexts/color-mode";
import { BranchMenu } from "@components/sidebar/branch-menu";
import Image from "next/image";
import React, { useContext, useEffect, useRef, useState } from "react";
import { AccountMenu } from "./account-menu";
import { GlobalSearch } from "./global-search";
import { ThemeToggle } from "./theme-toggle";
export const Header: React.FC = () => {
  const $ = _c(25);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = typeof window !== "undefined" ? window.location.hostname.split(".")[0] : "";
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const subdomain = t0;
  const [imageUrl, setImageUrl] = useState("/images/blueribbonSlogan.webp");
  const collapsed = useSideBarCollapse(_temp);
  const {
    primaryColor
  } = useContext(ColorModeContext);
  const searchRef = useRef(null);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = event => {
      if (event.ctrlKey && event.key === "k") {
        event.preventDefault();
        searchRef.current?.focus();
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleKeyDown = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      let image = "/images/blueribbonSlogan.webp";
      bb22: switch (subdomain) {
        case "kode":
          {
            image = "/images/kodeSloganTextUpdated.svg";
            break bb22;
          }
        case "ryze":
          {
            image = "/images/ryzeSloganText.svg";
          }
      }
      setImageUrl(image);
    };
    t3 = [subdomain];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    };
    t5 = [];
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  const t6 = collapsed ? 72 : 260;
  let t7;
  if ($[6] !== primaryColor || $[7] !== t6) {
    t7 = {
      backgroundColor: primaryColor,
      width: t6
    };
    $[6] = primaryColor;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== collapsed || $[10] !== primaryColor) {
    t8 = <BranchMenu colorPrimary={primaryColor} collapsed={collapsed} />;
    $[9] = collapsed;
    $[10] = primaryColor;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <div className="flex shrink-0 items-center justify-start gap-3"><div className="flex h-16 items-center justify-center rounded-2xl shadow-[0_8px_24px_hsl(var(--overlay)/0.18)] ring-1 ring-white/10 transition-[width]" style={t7}>{t8}</div></div>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== imageUrl) {
    t10 = <Image src={imageUrl} alt="kode image" width={320} height={64} sizes="320px" priority={true} fetchPriority="high" className="hidden h-16 w-[320px] shrink-0 object-contain md:block" />;
    $[15] = imageUrl;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex min-w-0 flex-1 items-center justify-end gap-3 px-2"><GlobalSearch ref={searchRef} className="w-full max-w-[460px]" placeholder={"Select a module, then search an item\u2026"} /></div>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex items-center gap-3"><ThemeToggle /><AccountMenu /></div>;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t10 || $[20] !== t9) {
    t13 = <header className="flex h-16 items-center justify-between gap-3 bg-background px-2">{t9}{t10}{t11}{t12}</header>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="mt-2 h-px w-full bg-border" />;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t13) {
    t15 = <div className="sticky top-0 z-[40] bg-background pt-2">{t13}{t14}</div>;
    $[23] = t13;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  return t15;
};
function _temp(state) {
  return state.collapsed;
}